__turbopack_context__.v({
  "card": "choose-module__H6h76W__card",
  "cardTitle": "choose-module__H6h76W__cardTitle",
  "cardWrapper": "choose-module__H6h76W__cardWrapper",
  "content": "choose-module__H6h76W__content",
  "grid": "choose-module__H6h76W__grid",
  "more": "choose-module__H6h76W__more",
  "readMore": "choose-module__H6h76W__readMore",
  "sectionTitle": "choose-module__H6h76W__sectionTitle",
  "wrapper": "choose-module__H6h76W__wrapper",
});
